import React from 'react'

export const fillHeader = items => {
  if(items[0] && typeof items[0] === 'string'){
    return items.map((item, index) => {
      let classes = 'cell'
      if (typeof items[index] === 'function') {
        return <div key={items[index].name}>{item()}</div>
      }
      return (
        <div key={item} className={classes}>
          {item}
        </div>
      )
    })
  } else if (items[0]){
    return items.map(item => {
      return item.format()
    })
  }
}

export default fillHeader